import config from '@/config';
import { gcmState } from '@/features/game-window-integration/helpers/GCM/state';

export const log = (...args: unknown[]): void => {
  console.log('>> GCM Helper:', ...args);
};

export const loadScript = (scriptUrl: string): Promise<HTMLScriptElement> =>
  new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(
      `script[src="${scriptUrl}"]`,
    );
    if (existing) {
      resolve(existing);
      return;
    }
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptUrl;
    script.addEventListener('load', () => resolve(script), false);
    script.addEventListener('error', () => reject(script), false);
    document.head.appendChild(script);
  });

export const resolveUrl = (region: string) => {
  const env = ['prod', 'darklive'].includes(process.env.NODE_CONFIG_ENV || '')
    ? 'prod'
    : 'stage';
  const gcmLibUrl = config?.gcmLib?.[region.toUpperCase()]?.[env];
  return gcmLibUrl;
};

export const setOGSParams = (osgParams: Record<string, unknown>): void => {
  gcmState.osgParams = osgParams;
};
